
// Helper function to round to 2 decimal places
const roundToTwoDecimals = (value) => {
    if (value === null || value === undefined || value === '') return 0
    const num = parseFloat(value)
    if (isNaN(num)) return 0
    return Math.round(num * 100) / 100
}

/**
 * Generates the Unified GSTR7 JSON
 * @param {string} gstinMaster - The Master GSTIN
 * @param {Array} records - Array of invoice records for this GSTIN
 * @param {string|number} month - Tax period month (1-12)
 * @param {string|number} year - Tax period year (YYYY)
 * @returns {Object} - The complete GSTR7 JSON object
 */
export const generateGstr7Json = (gstinMaster, records, month, year) => {
    if (!gstinMaster || !records || !Array.isArray(records)) {
        return null;
    }

    // Filter records ensuring they belong to the master GSTIN (safety check)
    // And strictly use the ones passed in. 

    // Group by GSTIN (Vendor) AKA Deductee GSTIN
    const vendorGroups = records.reduce((acc, row) => {
        const gstinVendor = row.gstinVendor
        if (!gstinVendor) return acc;

        if (!acc[gstinVendor]) {
            acc[gstinVendor] = []
        }
        acc[gstinVendor].push(row)
        return acc
    }, {})

    // Format period (MMYYYY)
    const fpMonth = String(month).padStart(2, '0');
    const fp = `${fpMonth}${year}`;

    // Create JSON structure
    const jsonData = {
        gstin: gstinMaster,
        fp: fp,
        tds: Object.keys(vendorGroups).map(gstinVendor => ({
            gstin_ded: gstinVendor,
            inv: vendorGroups[gstinVendor].map(row => ({
                inum: row.invoiceNo,
                idt: row.invoiceDate,
                ival: roundToTwoDecimals(row.invoiceValue),
                amt_ded: roundToTwoDecimals(row.taxableValue),
                iamt: roundToTwoDecimals(row.igst),
                camt: roundToTwoDecimals(row.cgst),
                samt: roundToTwoDecimals(row.sgst),
                flag: row.action || 'N' // Default to 'N' (New) if missing
            }))
        }))
    }

    return jsonData;
}
